/* eslint-disable import/extensions */
import * as React from 'react';
import { A11y, Keyboard, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'react';

import '../css/swiper.scss';
import '../css/virtual.scss';
import '../css/navigation.scss';

import '../css/key-art-poster-swiper-carousel.sass';

type ResponsiveType = {
  desktop: number;
  mobile: number;
};

interface KeyArtCarouselProps {
  // eslint-disable-next-line react/no-unused-prop-types
  theme?: 'night' | 'day';
  children: React.ReactElement[];
  id?: string;
  infiniteScroll?: boolean;
  slidesPerView?: ResponsiveType;
  slidesPerGroup?: ResponsiveType;
  spaceBetween?: number;
  navigation?: {
    desktop: boolean;
    mobile: boolean;
  };
  centeredSlides?: boolean;
  pagination?: boolean;
}

export default function KeyArtPosterSwiperCarousel(props: KeyArtCarouselProps) {
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const {
    infiniteScroll = false,
    slidesPerView = {
      desktop: 4,
      mobile: 2
    },
    slidesPerGroup = {
      desktop: 4,
      mobile: 2
    },
    spaceBetween = 12,
    navigation = {
      desktop: true,
      mobile: false
    },
    centeredSlides = false,
    pagination = false
  } = props;
  const children = React.Children.toArray(props.children).filter(
    (child: any) => {
      return React.isValidElement(child) && child.type !== React.Fragment;
    }
  );

  useEffect(() => {
    const listener = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', listener);

    return () => window.removeEventListener('resize', listener);
  }, []);

  let keyIndex = 0;

  return (
    <div id={props.id} className="key-art-poster-swiper-carousel">
      <Swiper
        loop={infiniteScroll}
        modules={[Navigation, Keyboard, A11y]}
        a11y={{ firstSlideMessage: '', lastSlideMessage: '' }}
        onAfterInit={(swiper) => {
          const wrapperElement =
            swiper.el.getElementsByClassName('swiper-wrapper');
          if (
            wrapperElement &&
            wrapperElement.length > 0 &&
            wrapperElement[0].attributes.getNamedItem('aria-live')
          ) {
            wrapperElement[0].attributes.removeNamedItem('aria-live');
          }

          if (
            swiper.navigation &&
            swiper.navigation.nextEl &&
            swiper.navigation.prevEl
          ) {
            // eslint-disable-next-line no-param-reassign
            swiper.navigation.nextEl.title = 'Next slide';
            // eslint-disable-next-line no-param-reassign
            swiper.navigation.prevEl.title = 'Previous slide';
          }
        }}
        aria-live="off"
        slidesPerView={
          screenSize < 768 ? slidesPerView.mobile : slidesPerView.desktop
        }
        slidesPerGroup={
          screenSize < 768 ? slidesPerGroup.mobile : slidesPerGroup.desktop
        }
        spaceBetween={spaceBetween}
        navigation={screenSize < 768 ? navigation.mobile : navigation.desktop}
        pagination={{ enabled: pagination, clickable: true }}
        keyboard={{ enabled: true }}
        centeredSlides={centeredSlides}
      >
        {children.map((child) => {
          keyIndex += 1;
          return <SwiperSlide key={keyIndex}>{child}</SwiperSlide>;
        })}
      </Swiper>
    </div>
  );
}
